export default {
  unsaved: {
    title: 'Zapisać zmiany?',
    description: 'Wprowadzono zmiany w tym kroku, które nie zostały jeszcze zapisane.',
    discard: 'Odrzuć',
    save_and_continue: 'Zapisz i kontynuuj',
  },
  title: 'Skonfiguruj swoją restaurację',
  nav: {
    completed: 'Ukończono',
    locked: 'Obsługiwane przez Twojego dostawcę',
    aria_label: 'Kroki uruchomienia',
    step_label: 'Krok {{number}}',
    section_label: 'Uruchomienie',
    back_to_home: 'Powrót do strony głównej',
  },
  owner_invite: {
    hint: 'Wolisz, żeby właściciel restauracji sam dokończył konfigurację? Zaproś go, a przejmie od miejsca, w którym skończyłeś.',
    sent: 'Zaproszenie wysłane do {{name}} ({{email}}) w dniu {{date}}.',
  },
  footer: {
    step_of: 'Krok {{current}} z {{total}}',
  },
  buttons: {
    next_task: 'Następne zadanie',
    cancel: 'Anuluj',
    back: 'Wstecz',
    next: 'Kontynuuj',
    save: 'Zapisz',
    exit: 'Wyjdź z konfiguracji',
    retry: 'Spróbuj ponownie',
  },
  errors: {
    progress_load_failed: 'Nie udało się załadować postępu konfiguracji dla tej restauracji.',
    linked_company_unavailable:
      'Ten link dotyczy restauracji, której nie można otworzyć, więc jesteś na swojej aktualnej.',
  },
  placeholder: {
    title: 'Ten krok wkrótce dostępny',
    description: 'Szkielet kreatora i śledzenie postępu są gotowe. Ta faza zostanie zbudowana w następnej kolejności.',
  },
  new_restaurant: {
    title: 'Nowa restauracja',
    menu: {
      title: 'Menu',
      description: 'Demo pomija onboarding, więc zaimportuj teraz jego menu.',
    },
    demo: {
      title: 'Nowe demo',
      description: 'Restauracja demonstracyjna do testów — pomija większość onboardingu.',
      label: 'Utwórz demo',
    },
    description: 'Powiedz nam, gdzie znajduje się ta restauracja. Wyszukamy ją w Google Maps.',
  },
  location: {
    edit_description: 'Zaktualizuj lokalizację tej restauracji.',
    cta: 'Utwórz restaurację',
    section: {
      address: 'Podstawowe informacje',
      group: 'Marka',
      group_description: 'Czy ta lokalizacja należy do marki, którą już posiadasz?',
    },
    form: {
      name: {
        label: 'Nazwa restauracji',
        placeholder: 'Szukaj swojej restauracji…',
        help: 'Zacznij pisać, aby wyszukać tę restaurację w Google Maps.',
      },
      address: {
        label: 'Adres',
        placeholder: 'Ulica i numer',
      },
      city: {
        label: 'Miasto',
      },
      zip_code: {
        label: 'Kod pocztowy',
      },
      country: {
        label: 'Kraj',
      },
      region: {
        label: 'Stan / Region',
        placeholder: 'Wybierz stan lub region',
      },
    },
    group: {
      aria_label: 'Opcje marki',
      deferred_hint: 'Nazwę marki i adres internetowy wybierzesz w ostatnim kroku.',
      existing: {
        title: 'Dodaj do istniejącej marki',
        description: 'Kolejna lokalizacja marki, którą już prowadzisz.',
        select_label: 'Marka',
        select_placeholder: 'Wybierz markę',
      },
      new: {
        title: 'Utwórz nową markę',
        description: 'Pojedyncza restauracja lub pierwsza lokalizacja nowej marki.',
      },
    },
    toasts: {
      update_failed: 'Nie udało się zapisać lokalizacji. Spróbuj ponownie.',
      created: 'Restauracja utworzona',
      create_failed: 'Nie udało się utworzyć restauracji. Spróbuj ponownie.',
    },
  },
  domain: {
    url_setup: {
      title: 'Adres zamówień online',
      description: 'Miejsce, w którym goście będą składać zamówienia.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'Twoja domena zamówień online',
        title: 'Użyj naszej domeny ogólnej',
      },
      custom: {
        title: 'Połącz własną domenę',
        description: 'Użyj domeny, którą restauracja już posiada.',
      },
    },
    toasts: {
      save_failed: 'Nie udało się zapisać adresu zamówień online. Spróbuj ponownie.',
    },
  },
  go_live: {
    subtitle: 'Upewnij się, że każdy krok jest ukończony, a następnie włącz zamówienia na żywo.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: 'Tylko litery, cyfry i myślniki. Możesz to zmienić później, ale stary adres przestanie działać.',
      title: 'Adres zamówień online',
      description: 'Tu Twoi klienci będą składać zamówienia. Możesz to zmienić później.',
      label: 'Dostosuj nazwą restauracji',
      placeholder: 'bella-italia',
      preview: 'Twoja strona zamówień:',
      save: 'Zapisz URL',
      saved: 'Adres zamówień online zapisany',
      save_failed: 'Nie można zapisać adresu URL. Spróbuj ponownie.',
      status: {
        checking: 'Sprawdzanie dostępności…',
        available: 'Dostępna',
        taken: 'Ten adres URL jest już zajęty',
        invalid: 'Używaj tylko liter, cyfr, myślników i podkreśleń',
        error: 'Nie udało się sprawdzić dostępności — spróbuj ponownie',
      },
    },
    domain: {
      title: 'Własna domena (opcjonalnie)',
      description: 'Użyj własnej domeny zamiast adresu udostępnianego przez FoodAmigos.',
      add: '+ Dodaj własną domenę',
      hide: 'Ukryj własną domenę',
      label: 'Twoja domena',
      placeholder: 'shop.myrestaurant.com',
      save: 'Zapisz',
      show_records: 'Pokaż rekordy DNS',
      hint: 'Tylko do zamówień — strona internetowa potrzebuje innej domeny. Na przykład order.mojarestauracja.pl dla sklepu i mojarestauracja.pl dla strony.',
      records_after_save:
        'Po zapisaniu domeny pokażemy dokładnie, jakie rekordy należy dodać u dostawcy DNS — domena główna (mojarestauracja.pl) i subdomena (order.mojarestauracja.pl) wymagają różnych rekordów.',
      saved: 'Własna domena zapisana',
      save_failed: 'Nie można zapisać domeny. Spróbuj ponownie.',
      unconfirmed: {
        title: 'Przejście na żywo nie czeka na tę domenę',
        description:
          'Dopóki jej rekordy nie zostaną potwierdzone, strona zamówień pozostaje pod standardowym adresem i restauracja może tam zostać uruchomiona. Po ich potwierdzeniu — może to potrwać do 48 godzin — domena zacznie automatycznie wyświetlać stronę zamówień.',
      },
    },
    locations: {
      title: 'Potwierdź lokalizacje',
      description: 'Każda lokalizacja w Twojej marce ma własny adres zamówień. Potwierdź lub edytuj je poniżej.',
      save: 'Zapisz lokalizacje',
      saved: 'Adresy URL lokalizacji zapisane',
      save_failed: 'Nie można zapisać jednego lub więcej adresów URL lokalizacji. Spróbuj ponownie.',
    },
    preflight: {
      title: 'Przed przejściem na żywo',
      description: 'Uzupełnij poniższe, aby włączyć zamówienia na żywo.',
      url_setup: 'Adres zamówień skonfigurowany',
      online_payment: {
        your_provider: 'Twój dostawca',
        payments_live: '{{title}} · gotowe',
        online_payments_off: '{{title}} · brak płatności online',
        waiting_for_provider: '{{title}} · oczekiwanie na {{provider}}',
        hosted_not_finished: '{{title}} · dokończ w {{provider}}',
        action_needed: '{{title}} · wymagane działanie',
        waiting_for_partner: '{{title}} · oczekiwanie na partnera',
        not_set_up: '{{title}} · nieskonfigurowane',
        business_details_missing: '{{title}} · dodaj dane firmy do wypłat',
      },
    },
    failed_checks: {
      title: 'Kilka rzeczy wymaga jeszcze uwagi',
      items: {
        name: 'Nazwa restauracji',
        logo_url: 'Logo',
        pictures: 'Zdjęcia w galerii',
        menu_uploaded: 'Menu',
        opening_hours: 'Godziny otwarcia',
        address: 'Adres',
        storefront: 'Adres zamówień',
        payments_configured: 'Płatności',
        stripe_billing: 'Rozliczenia',
        test_orders: 'Zamówienie testowe',
        google_business: 'Profil Google Business',
        master_promo_code: 'Powitalny kod promocyjny',
        flyers_ordered: 'Ulotki zamówione',
        identity: 'Typ restauracji i kuchnie',
        billing_payment_method: 'Metoda płatności',
        billing_license: 'Licencja',
        business_name: 'Nazwa firmy / restauracji',
        payment_method: 'Gotówka lub płatności online',
        stripe_processing_fee: 'Prowizja partnera za przetwarzanie',
      },
      force: 'Przejdź na żywo mimo to',
      blocker: '(wymagane)',
      link: 'Otwórz Partner Billing',
    },
    error: 'Nie można włączyć zamówień na żywo. Spróbuj ponownie.',
    gate_hint: 'Wypełnij powyższą listę kontrolną, aby włączyć Przejście na żywo.',
    business_name: {
      label: 'Nazwa firmy / restauracji',
      help: 'Widoczna w warunkach korzystania i polityce prywatności. Użyj nazwy, pod którą działa Twoja firma.',
      save: 'Zapisz',
      save_failed: 'Nie udało się zapisać nazwy firmy. Spróbuj ponownie.',
      hint: 'Najpierw zapisz nazwę firmy / restauracji.',
    },
    cash_only: {
      message:
        'Płatności online są wyłączone — klienci mogą płacić tylko gotówką przy odbiorze lub dostawie, dopóki bramka płatności nie zostanie połączona i zweryfikowana.',
    },
    payment_blocked: {
      title: 'Włącz płatności gotówką lub skonfiguruj płatności online, aby uruchomić.',
      payment_method: 'Klienci potrzebują sposobu płatności.',
      turn_on_cash: 'Włącz płatności gotówką',
      ask_partner: 'Poproś partnera o włączenie płatności gotówką lub',
      set_up_online: 'skonfiguruj płatności online',
    },
    buttons: {
      go_live: 'Przejdź na żywo 🚀',
      finish: 'Zakończ konfigurację',
    },
    celebration: {
      title: 'Jesteś na żywo!',
      title_named: '{{name}} jest już aktywny!',
      subtitle: 'Twoja restauracja przyjmuje teraz zamówienia na żywo.',
      license: '{{plan}} · aktywny',
      license_trial: '{{plan}} · bezpłatnie do {{date}}',
      finish: 'Zakończ konfigurację',
    },
    service_fee: {
      title: 'Opłata serwisowa',
      headline: 'Zarabiaj więcej, bez obciążania swoich restauracji',
      subtitle:
        'Dodaj niewielką opłatę serwisową, którą goście płacą przy składaniu zamówienia. Połowa trafia do Ciebie. Opłata jest wyłączona, dopóki jej nie włączysz.',
      subtitle_share:
        'Dodaj niewielką opłatę serwisową, którą goście płacą przy składaniu zamówienia. {{share}}% trafia do Ciebie. Opłata jest wyłączona, dopóki jej nie włączysz.',
      tiles: {
        guest: {
          title: 'Płaci gość',
          description: 'Widoczna przy płatności, jak w aplikacjach do dostaw.',
        },
        share: {
          title: 'Połowa trafia do Ciebie',
          title_share: '{{share}}% trafia do Ciebie',
          description: 'Podział {{share}}/{{rest}} z FoodAmigos.',
        },
        choice: {
          title: 'Twój wybór',
          description: 'Domyślnie wyłączona. Zmienisz to w każdej chwili.',
        },
      },
      preview: {
        title: 'Co goście zobaczą przy płatności',
        subtotal: 'Suma częściowa zamówienia',
        fee: 'Opłata serwisowa',
        fee_terms: '({{percentage}}%, maks. {{max}})',
        guest_pays: 'Gość płaci',
        split_partner: '<strong>Ty {{amount}}</strong> za zamówienie',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'Wartość zamówienia w restauracji pozostaje bez zmian.',
      },
      earnings: {
        title: 'Ile możesz zarobić na tej restauracji',
        orders: 'Zamówienia online miesięcznie',
        average_order: 'Średnie zamówienie',
        per_month: 'miesięcznie dla Ciebie',
        collected: '{{amount}} pobrane od gości miesięcznie. Twój udział: {{share}}%. Tylko szacunek.',
        effective_rate: 'Efektywna stawka opłaty dla wszystkich zamówień: {{rate}}',
      },
      choice: {
        question: 'Dodać opłatę serwisową dla tej restauracji?',
        enabled: {
          title: 'Dodaj opłatę serwisową',
          recommended: 'Zalecane: {{percentage}}%, maks. {{max}}',
          description: 'Goście płacą niewielką opłatę. Ty zarabiasz udział.',
        },
        skipped: {
          title: 'Bez opłaty serwisowej',
          description: 'Goście płacą tylko ceny z menu.',
        },
      },
      footer: {
        enabled:
          'Goście płacą {{percentage}}%, maks. {{max}} za zamówienie. Zmienisz to w każdej chwili w <settings>Ustawienia zamówień → Opłata serwisowa</settings>.',
        skipped:
          'Na razie bez opłaty serwisowej. Zmienisz to w każdej chwili w <settings>Ustawienia zamówień → Opłata serwisowa</settings>.',
      },
      enabled:
        'Opłata serwisowa jest teraz aktywna w tej restauracji i wynosi {{percentage}}%, maksymalnie {{max}} na zamówienie. Obowiązuje dla wszystkich nowych zamówień od teraz. Możesz ją zmienić w dowolnym momencie w <settings>Ustawienia zamówień → Opłata serwisowa</settings>.',
      enabled_partner_default:
        'Opłata serwisowa jest teraz aktywna w tej restauracji. Obowiązuje domyślna wartość partnera: {{percentage}}%, maksymalnie {{max}} na zamówienie. Obowiązuje dla wszystkich nowych zamówień od teraz. Możesz ją zmienić w dowolnym momencie w <settings>Ustawienia zamówień → Opłata serwisowa</settings>.',
      buttons: {
        enable: 'Włącz opłatę serwisową',
        continue_without: 'Kontynuuj bez opłaty',
      },
      skipped:
        'Goście tej restauracji nie płacą opłaty serwisowej. Możesz ją włączyć w dowolnym momencie w <settings>Ustawienia zamówień → Opłata serwisowa</settings>.',
      toasts: {
        save_failed: 'Nie udało się zapisać wyboru opłaty serwisowej. Spróbuj ponownie.',
      },
    },
  },
  toasts: {
    save_failed: 'Nie można zapisać zmian. Spróbuj ponownie.',
    saved: 'Zapisano',
  },
  optional: 'Opcjonalne',
  identity: {
    min_cuisine_hint: 'Wybierz co najmniej jedną kuchnię, aby kontynuować.',
    sections: {
      restaurant_type: {
        title: 'Typ restauracji',
        description: 'Jaki to rodzaj lokalu?',
      },
      cuisine: {
        title: 'Rodzaje kuchni',
        description: 'Wybierz co najmniej jedną.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Polecane',
      import: {
        title: 'Importuj z platformy',
        description: 'Pobierz menu z Wolt, Lieferando, Deliveroo i innych.',
      },
      manual: {
        title: 'Zbuduj menu od podstaw',
        description: 'Twórz kategorie i pozycje ręcznie w kreatorze menu.',
      },
    },
    import: {
      title: 'Importuj z istniejącej platformy',
      in_progress: {
        title: 'Importowanie menu…',
        description: 'Zwykle trwa to poniżej dwóch minut. Ukończymy ten krok, gdy tylko się zakończy.',
      },
      failed: {
        title: 'Import nie został ukończony',
        description: 'Nie można ukończyć importu menu. Sprawdź szczegóły i spróbuj ponownie.',
      },
      blocked: {
        until: 'Wstrzymano do {{time}}',
        release: 'Zwolnij link',
        released: 'Link został zwolniony. Możesz ponownie rozpocząć import.',
        release_failed: 'Nie udało się zwolnić linku. Spróbuj ponownie za chwilę.',
      },
      stalled: {
        title: 'Wciąż importuję…',
        description:
          'Import trwa dłużej niż zwykle. Może nadal działać w tle — sprawdź ponownie za chwilę. Rozpoczęcie nowego importu teraz może spowodować dwukrotne zaimportowanie menu.',
      },
    },
    manual: {
      title: 'Zbuduj menu od podstaw',
      description:
        'Kreator menu otwiera się z pustym menu. Ten krok jest ukończony, gdy istnieje co najmniej jedna kategoria i jedna pozycja.',
      open_editor: 'Otwórz kreator menu',
      waiting: {
        title: 'Oczekiwanie na pierwszą pozycję menu',
        description: 'Gdy dodasz pozycję w edytorze menu, ten krok zostanie ukończony.',
      },
      found: {
        title: 'Wykryto pozycje menu',
        description: 'Świetnie — możesz przejść do następnego kroku.',
      },
    },
    complete: {
      title: 'Menu gotowe',
      description: 'Twoje menu jest gotowe. Możesz je przejrzeć w dowolnym momencie w edytorze menu.',
    },
    buttons: {
      start_import: 'Rozpocznij import',
      importing: 'Importowanie…',
      retry: 'Ponów import',
      check_again: 'Sprawdź ponownie',
      continue: 'Kontynuuj',
      skip: 'Pomiń na razie',
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'tej restauracji',
    location: {
      title: 'Lokalizacja',
      description: 'Gdzie znajduje się restauracja i do jakiej marki należy?',
    },
    identity: {
      title: 'Tożsamość',
      description: 'Typ restauracji i kuchnie.',
    },
    brand: {
      title: 'Marka',
      description: 'Logo, kolory i galeria.',
    },
    operations: {
      title: 'Szczegóły lokalizacji',
      description:
        'Skonfiguruj sposób przyjmowania zamówień przez {{name}}. To minimum wymagane przed przyjęciem jakiegokolwiek zamówienia.',
    },
    menu: {
      title: 'Menu',
      description:
        'Umieść menu {{name}} na platformie. Importuj z istniejącej platformy w mniej niż dwie minuty lub zbuduj od podstaw.',
    },
    domain: {
      title: 'Domena',
      description: 'Adres internetowy, którego klienci używają do zamawiania z tej restauracji.',
    },
    go_live: {
      title: 'Przejście na żywo',
      description: 'Włącz zamówienia na żywo.',
    },
    payouts: {
      title: 'Płatność online',
      description: 'Jak ta restauracja przyjmuje płatności online.',
    },
    service_fee: {
      title: 'Opłata serwisowa',
      description:
        'Czy goście płacą opłatę serwisową przy kasie. Możesz to zmienić później w Ustawienia zamówień → Opłaty.',
    },
    bank_account: {
      title: 'Konto bankowe',
      description:
        'Miejsce, na które trafiają wypłaty. Nie jest wymagane do uruchomienia: płatności czekają na saldzie do czasu dodania konta.',
    },
  },
  business_details: {
    locked: 'Te dane są zweryfikowane u dostawcy płatności. Aby je zmienić, skontaktuj się z FoodAmigos.',
    section: {
      title: 'Dane firmy',
    },
    fields: {
      business_type: {
        label: 'Rodzaj działalności',
        options: {
          company: 'Firma (GmbH, UG, Ltd, Inc — zarejestrowany podmiot prawny)',
          individual: 'Osoba fizyczna (prowadzisz działalność osobiście)',
        },
      },
      owner_first_name: { label: 'Imię właściciela' },
      owner_last_name: { label: 'Nazwisko właściciela' },
      legal_name: {
        label: 'Nazwa prawna firmy',
        individual:
          'Prowadzisz działalność osobiście, więc jako nazwa prawna firmy używane jest imię i nazwisko właściciela.',
      },
      legal_address: { label: 'Adres rejestrowy' },
      legal_city: { label: 'Miasto' },
      legal_state: { label: 'Województwo lub region' },
      legal_zip_code: { label: 'Kod pocztowy' },
      legal_country: { label: 'Kraj' },
      tax_id: {
        generic: 'Numer podatkowy lub rejestracyjny',
        personal: 'Widoczne są tylko ostatnie cztery cyfry. Pozostaw bez zmian, aby zachować numer.',
        hint: 'Na przykład {{example}}.',
        invalid: 'To nie pasuje do zwykłego formatu dla tego kraju i typu działalności, na przykład {{example}}.',
      },
      is_vat_registered: { label: 'Ta firma jest zarejestrowana jako podatnik VAT' },
      vat_id: {
        label: 'Numer VAT',
        help: 'Zaczyna się od {{country}}, po którym następuje od 8 do 12 liter lub cyfr.',
        invalid: 'Numer VAT musi zaczynać się od {{country}}, po którym następuje od 8 do 12 liter lub cyfr.',
        help_unprefixed: 'Twój numer VAT lub numer rejestracji podatkowej, zgodnie z wydaniem.',
        invalid_unprefixed: 'To nie wygląda na numer VAT: użyj od 5 do 25 liter lub cyfr.',
      },
    },
    toasts: {
      save_failed: 'Nie udało się zapisać danych firmy. Spróbuj ponownie.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Krótka nazwa',
        placeholder: 'np. Amigo Pizza',
        tooltip: 'Krótsza nazwa wyświetlana w witrynie i na paragonach.',
      },
      primary_color: {
        label: 'Kolor główny',
        invalid: 'Podaj prawidłowy kolor hex, np. #1A73E8.',
      },
    },
    sections: {
      short_name: 'Nazwa',
      short_name_hint: 'Używana w witrynie, na paragonach i w powiadomieniach.',
      logo_and_colour: 'Logo i główny kolor marki',
      logo: 'Prześlij logo',
      logo_hint: 'Jeśli to pole pozostanie puste, użyte zostanie logo Twojej marki.',
      gallery: 'Zdjęcia w galerii',
      gallery_hint: 'Dodaj do {{max}} zdjęć restauracji. Przeciągnij, aby zmienić kolejność.',
      gallery_count: '{{count}} z {{max}} dodanych',
    },
    toasts: {
      image_uploaded: 'Zdjęcie przesłane',
      image_upload_failed: 'Nie udało się przesłać zdjęcia. {{error}}',
      save_failed: 'Nie udało się zapisać danych marki. Spróbuj ponownie.',
    },
  },
  operations: {
    contact: {
      title: 'Kontakt',
      description: 'Używane do powiadomień o zamówieniach i komunikacji z klientami.',
      phone: {
        label: 'Numer telefonu restauracji',
        placeholder: '+49 30 1234567',
        invalid: 'Podaj pełny numer w formacie międzynarodowym, np. +49 30 1234567',
      },
      email: { label: 'E-mail restauracji', placeholder: 'orders@restaurant.com' },
    },
    methods: {
      title: 'Metody zamówień',
      description: 'Jak klienci mogą zamawiać i ile czasu zajmuje każda metoda.',
      pickup: {
        label: 'Odbiór',
        prep_time: { label: 'Średni czas przygotowania (min)' },
      },
      delivery: {
        label: 'Dostawa',
        delivery_time: { label: 'Średni czas dostawy (min)' },
        advanced_zones: 'Zaawansowana konfiguracja stref',
      },
    },
    timing: {
      title: 'Czas zamówień',
      description: 'Kiedy klienci mogą składać zamówienia — teraz, później lub z wyprzedzeniem.',
      at_least_one: 'Włącz zamówienia natychmiastowe lub zaplanowane (wymagane jest co najmniej jedno).',
      asap: { label: 'Przyjmuj zamówienia natychmiastowe' },
      scheduled: { label: 'Przyjmuj zamówienia zaplanowane' },
      reminders: { label: 'Wyślij automatyczne przypomnienie przed terminem zamówienia zaplanowanego' },
      pre_order: {
        label: 'Zezwalaj na zamówienia z wyprzedzeniem na przyszłe dni',
        days: { label: 'Ile dni z wyprzedzeniem (0–31)' },
      },
    },
    tax: {
      title: 'VAT',
      description:
        'Stawka stosowana do produktów tej restauracji. Domyślnie to stawka dla regionu — zmień ją tylko wtedy, gdy ta restauracja nalicza inną.',
      rate: { label: 'Stawka VAT', placeholder: 'np. 7' },
      dedicated: { label: 'VAT różni się w zależności od produktu' },
    },
    hours: {
      title: 'Godziny otwarcia',
      description: 'Dni i godziny, w których restauracja przyjmuje zamówienia.',
      same_every_day: 'Te same godziny każdego dnia',
      split_shifts: {
        title: 'Ta restauracja ma podzielone godziny otwarcia',
        description:
          'Niektóre dni mają więcej niż jeden okres otwarcia (np. pora lunchu i kolacji). Prosty edytor pokazuje jeden okres na dzień, dlatego zachowujemy istniejące godziny bez zmian — edytuj podzielone zmiany w Ustawieniach zamówień → Godziny otwarcia.',
      },
    },
    toasts: {
      save_failed: 'Nie udało się zapisać ustawień operacyjnych. Spróbuj ponownie.',
    },
  },
  online_payment: {
    question: 'Czy chcesz przyjmować płatności online dla tej restauracji?',
    yes: 'Tak',
    not_now: 'Nie teraz',
    declined:
      'Klienci zapłacą przy odbiorze lub dostawie. Płatności online możesz włączyć w dowolnym momencie w Ustawieniach.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Płatności nie zostały jeszcze skonfigurowane dla Twojego konta partnera',
        description:
          'Administrator Twojego konta partnera musi wybrać, kto obsługuje płatności, zanim ta restauracja będzie mogła przyjmować płatności online. W międzyczasie możesz kontynuować pozostałe kroki.',
      },
    },
    continue_to_go_live: 'Przejdź do uruchomienia',
    platform_line: 'Płatności dla tej restauracji są obsługiwane przez FoodAmigos payments.',
    only_connection: 'Płatności są obsługiwane przez {{name}} (Twój jedyny podłączony dostawca).',
    partner_issue: {
      title: 'Twój partner {{partner}} musi dokończyć konfigurację swojego dostawcy płatności',
      description:
        'Ich dostawca płatności nie może jeszcze wdrażać restauracji. Powiadomiliśmy partnera — Twoje dane zostały zapisane, więc wróć, gdy potwierdzi, że to załatwione.',
      retry_hint: 'Gdy problem zostanie rozwiązany, przejdź ponownie do dostawcy, a spróbujemy jeszcze raz.',
      open_settings: 'Otwórz ustawienia bramki płatności',
    },
    connect_another: 'Podłącz kolejnego dostawcę',
    checking: 'Sprawdzanie u {{provider}}…',
    checking_generic: 'Sprawdzanie u dostawcy płatności…',
    retry: 'Spróbuj ponownie',
    not_set_up: {
      title: 'Brak połączonego dostawcy płatności',
      description:
        'Twój partner łączy dostawcę płatności z tą restauracją. Gdy to zrobi, będziesz mógł dokończyć konfigurację tutaj.',
    },
    choice: {
      title: 'Którego z podłączonych dostawców powinna używać ta restauracja?',
      primary: 'Podstawowy',
      confirm: 'Użyj tego dostawcy',
      cancel: 'Anuluj',
    },
    using: 'Używa {{name}}',
    change: 'Zmień',
    payout_details: {
      title: 'Dane firmy do wypłat',
      description: 'Wymagane przez operatora płatności do weryfikacji firmy i przesyłania wypłat.',
      business_type: {
        company: {
          title: 'Firma',
          description: 'GmbH, sp. z o.o., Ltd, Inc — zarejestrowany podmiot prawny',
        },
        individual: {
          title: 'Osoba fizyczna',
          description: 'Osobiście jesteś właścicielem i prowadzisz działalność',
        },
      },
      registered_address: 'Adres rejestrowy',
      legal_address: 'Adres',
      legal_state: 'Stan / region',
      vat_id: 'Numer VAT',
      optional: '(opcjonalnie)',
      fill_first: 'Najpierw uzupełnij powyżej dane firmy do wypłat.',
    },
    hand_off: {
      title: 'Dalej: dokończ konfigurację w {{provider}}',
      description:
        '{{provider}} poprosi o dokument tożsamości właściciela we własnym formularzu, korzystając z danych firmy do wypłat podanych powyżej. Około 10 minut. Konto bankowe dodaje się po uruchomieniu.',
      cta: 'Przejdź do {{provider}}',
      transition: 'Przekierowujemy do {{provider}}…',
      error: 'Nie udało się otworzyć formularza {{provider}}. Spróbuj ponownie.',
    },
    states: {
      verified: 'Płatności są aktywne.',
      submitted: {
        title: 'Dane wysłane do {{provider}}',
        description:
          'Weryfikacja trwa zwykle 1–2 dni robocze. Wyślemy e-mail do właściciela restauracji, gdy będzie gotowa.',
        description_email: 'Weryfikacja zwykle trwa 1–2 dni robocze. Wyślemy e-mail na {{email}}, gdy będzie gotowa.',
        review: {
          business_type: 'Rodzaj działalności',
          legal_name: 'Nazwa prawna',
          address: 'Adres rejestrowy',
          types: {
            company: 'Firma',
            individual: 'Osoba fizyczna',
          },
        },
      },
      incomplete: {
        title: 'Nie dokończyłeś konfiguracji z {{provider}}',
        description: 'Twoje dane zostały zapisane — link jest ważny przez 2 dni.',
        expired: 'Twoje dane zostały zapisane, ale link wygasł.',
        cta: 'Kontynuuj z {{provider}}',
        new_link: 'Pobierz nowy link i kontynuuj',
        check_details: 'Najpierw sprawdź moje dane',
      },
      action_needed: {
        title: '{{provider}} potrzebuje jeszcze jednej rzeczy',
        description:
          '{{provider}} nie mógł zweryfikować jednej z podanych informacji. Otwórz ponownie ich formularz, aby to poprawić.',
        cta: 'Otwórz ponownie formularz {{provider}}',
      },
    },
    connected: {
      title: 'Płatności realizowane przez {{name}}',
      description: 'Ta restauracja jest połączona z kontem {{name}} — nie ma tu nic więcej do skonfigurowania.',
      failed: 'Nie udało się jeszcze połączyć tej restauracji z {{name}}',
    },
    errors: {
      generic: 'Coś poszło nie tak. Spróbuj ponownie.',
      load_failed: 'Nie udało się wczytać konfiguracji płatności tej restauracji.',
    },
  },
  bank_account: {
    section: {
      title: 'Konto bankowe do wypłat',
      description: 'Wypłaty są realizowane w walucie {{currency}}, w której ta restauracja przyjmuje płatności.',
    },
    done: 'Wróć do panelu',
    load_failed: 'Nie udało się wczytać konta bankowego tej restauracji.',
    retry: 'Spróbuj ponownie',
    no_permission: 'Konto bankowe może wprowadzić tylko właściciel restauracji lub partner.',
    confirm_with_provider: 'Potwierdź w Adyen',
    toasts: {
      save_failed: 'Nie udało się zapisać konta bankowego. Sprawdź dane.',
    },
  },
  payouts: {
    finish_setup: 'Zakończ konfigurację',
  },
};
